// @ts-expect-error
import {PropTypes} from 'prop-types';

export const INACCESSIBLE_INFO_SHAPE = PropTypes.shape({
  invalidId: PropTypes.string.isRequired,
});
